import { DialogTrigger as SpectrumDialogTrigger } from '@adobe/react-spectrum';
import { Button, variant } from './button';
import { Dialog, DialogButtonProps, dialogSize } from './dialog';
import styled from 'styled-components';

interface DialogTriggerProps {
  // ダイアログ表示状態
  isOpen: boolean;
  // ダイアログ表示状態変更イベント
  onOpenChange?: () => void;
  buttonVariant?: variant;
  buttonContent: React.ReactNode;
  margin?: number;
  dialogSize?: dialogSize;
  title: React.ReactNode;
  children: React.ReactNode;
  mainButtonProps: DialogButtonProps;
  subButtonProps?: DialogButtonProps;
  minWidth?: number;
}

interface CustomButtonProps {
  minWidth: number;
}
const CustomButton = styled(Button)<CustomButtonProps>`
  min-width: ${(props) =>
    props.minWidth !== 0 ? props.minWidth + 'px;' : 'auto;'};
`;

export const DialogTrigger = (props: DialogTriggerProps) => {
  const {
    isOpen,
    onOpenChange,
    buttonVariant,
    buttonContent,
    margin,
    dialogSize,
    title,
    children,
    mainButtonProps,
    subButtonProps,
    minWidth = 0,
  } = props;
  return (
    <SpectrumDialogTrigger
      type="modal"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      {/* ダイアログ表示ボタン */}
      <CustomButton variant={buttonVariant} margin={margin} minWidth={minWidth}>
        {buttonContent}
      </CustomButton>
      {/* ダイアログ本体 */}
      <Dialog
        size={dialogSize}
        title={title}
        children={children}
        mainButtonProps={mainButtonProps}
        subButtonProps={subButtonProps}
      />
    </SpectrumDialogTrigger>
  );
};
